import axios from "@/api/axiosInstance";
import { FetchTeamsRequest, FetchTeamsResponse } from "./types";

export const fetchTeams = async (
  params: FetchTeamsRequest = {},
): Promise<FetchTeamsResponse> => {
  const response = await axios.get<FetchTeamsResponse>(
    "/api/private/employee-directory/teams",
    { params },
  );
  return response.data;
};
